import { getAttributeValue } from '@boc/framework/products/attributes';
import type { ProductCardFragment } from '@boc/framework/saleor-graphql';

export const isOwnProduct = (product: ProductCardFragment) => {
  const puzzlePublisher = getAttributeValue(product.attributes, 'puzzle-publisher');
  return puzzlePublisher == 'Jigsaw Nation';
};
